import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

// Inverse of PrivateRoute: redirects already-signed-in users away from
// /login and /signup (otherwise they'd see the auth form despite being
// logged in, which is confusing).
export default function PublicRoute() {
  const [authState, setAuthState] = React.useState('loading');

  React.useEffect(() => {
    let cancelled = false;
    getCurrentUser()
      .then(() => { if (!cancelled) setAuthState('authenticated'); })
      .catch(() => { if (!cancelled) setAuthState('unauthenticated'); });
    return () => { cancelled = true; };
  }, []);

  if (authState === 'loading') {
    return (
      <div className="app-loading">
        <div className="loading-spinner" />
      </div>
    );
  }
  if (authState === 'authenticated') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
